import {combineReducers} from 'redux';
import login from "./login";
import loader from "./loader";
import crud from "./crud";
import theme from "./theme";
import user from "./user";
import feature from "./feature";
import signalr from "./signalr";
import investmentaccount from "./investmentaccount";

const rootReducer = combineReducers({
    login, 
    loader,
    crud,
    theme,
    user,
    feature,
    signalr,
    investmentaccount
});

export default rootReducer;